/*
 * @Author: edvardchen
 * @Date: 2017-10-18 16:54:44
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-10-10 17:04:42
 */

// @flow
import querystring from 'query-string';
import _ from 'lodash';
import urlUtil from '../utility/url';
import isomorphicConfig from '../utility/isomorphicConfig';
import { parseJSON, checkStatus } from './helper';

type Options = {
  method: 'GET' | 'PUT' | 'POST' | 'DELETE',
  credentials?: boolean,
  headers?: Object,
  body?: Object,
};
type Opts = *;

const rSelfHostPath = /^\/(?![/])/;
const fetch = (_url: string, { credentials = true, method, conType, body, ...rest }: Options) => {
  const opts: Opts = { method, ...rest };
  let url = _url;
  // 通过newsHost来判断是否运行在本项目的同名域名下
  // 下发了newsHost，表示运行在news域名下，fetch请求需要显式指定域名
  if (isomorphicConfig.newsHost) {
    if (rSelfHostPath.test(url)) {
      url = `${isomorphicConfig.newsHost}${url}`;
    }
  }

  if (credentials) {
    const { host } = urlUtil.parse(url);
    opts.credentials = host === window.location.host ? 'same-origin' : 'include';
  }
  switch (method) {
    case 'POST':
    case 'PUT':
      opts.headers = {
        ...opts.headers,
        'Content-Type': conType || 'application/x-www-form-urlencoded',
      };
      opts.body = typeof body === 'object' ? querystring.stringify(body) : body;
      break;
    default:
      // opts.headers = headers;
      break;
  }
  const urlObject = urlUtil.parse(window.location.href);
  const gray = _.get(urlObject, 'query.gray') || '';
  if (gray === 'T_T') {
    const fetchUrlObject = urlUtil.parse(url);
    fetchUrlObject.query = Object.assign(fetchUrlObject.query || {}, { gray });
    url = urlUtil.format(fetchUrlObject);
  }

  return window
    .fetch(url, opts)
    .then(checkStatus)
    .then(parseJSON)
    .then((json) => json)
    .catch((e) => {
      console.log(`[${method}] ${url} failed`, e);
      throw e;
    });
};

export const get = (url: string, options: *) =>
  fetch(url, {
    ...options,
    method: 'GET',
  });

export const post = (url: string, options: *) =>
  fetch(url, {
    ...options,
    method: 'POST',
  });

export const put = (url: string, options: *) =>
  fetch(url, {
    ...options,
    method: 'PUT',
  });

export default fetch;
